import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { MarketingLayout } from '@/components/layout/MarketingLayout';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { cognitoConfirm, cognitoResendCode, mapCognitoErrorMessage } from '@/lib/cognito';
import { useToast } from '@/components/ui/use-toast';

export function ConfirmarEmail() {
  const [params] = useSearchParams();
  const initialEmail = params.get('email') ?? '';
  const [email, setEmail] = useState(initialEmail);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  async function handleConfirm() {
    if (!/^\d{6}$/.test(code)) {
      toast({ variant: 'warning', title: 'Código de 6 dígitos' });
      return;
    }
    setLoading(true);
    try {
      await cognitoConfirm(email, code);
      toast({ variant: 'success', title: 'Email confirmado', description: 'Você já pode entrar.' });
      navigate('/login');
    } catch (err) {
      toast({ variant: 'danger', title: 'Falha na confirmação', description: mapCognitoErrorMessage(err) });
    } finally {
      setLoading(false);
    }
  }

  async function handleResend() {
    setResending(true);
    try {
      await cognitoResendCode(email);
      toast({ variant: 'success', title: 'Código reenviado', description: `Verifique ${email}` });
    } catch (err) {
      toast({ variant: 'danger', title: 'Falha ao reenviar', description: mapCognitoErrorMessage(err) });
    } finally {
      setResending(false);
    }
  }

  return (
    <MarketingLayout>
      <div className="container-px mx-auto max-w-md py-16">
        <Card>
          <CardHeader>
            <CardTitle>Confirme seu email</CardTitle>
            <CardDescription>Digite o código de 6 dígitos que enviamos para você.</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="code">Código</Label>
              <Input
                id="code"
                inputMode="numeric"
                maxLength={6}
                placeholder="000000"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
                className="mt-1.5 text-center text-2xl tracking-[0.5em] font-serif"
              />
            </div>
            <Button onClick={handleConfirm} variant="accent" className="w-full" loading={loading}>
              Confirmar
            </Button>
            <div className="flex items-center justify-between text-sm">
              <Button variant="link" onClick={handleResend} loading={resending}>
                Reenviar código
              </Button>
              <Link to="/login" className="text-muted-foreground hover:text-foreground">
                Voltar ao login
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </MarketingLayout>
  );
}
